import { observer } from 'mobx-react-lite'
import { CompleteInfoGatheringEarlyConfirmationDialog } from './index'
import type { TaxInfoGatheringViewModel } from '../../TaxInfoGatheringViewModel'

export interface CompleteInfoGatheringEarlyConfirmationDialogContainerProps {
  vm: TaxInfoGatheringViewModel
}

export const CompleteInfoGatheringEarlyConfirmationDialogContainer = observer(
  function CompleteInfoGatheringEarlyConfirmationDialogContainer({
    vm,
  }: CompleteInfoGatheringEarlyConfirmationDialogContainerProps) {
    const testId = 'complete-info-gathering-early-confirmation-dialog'
    return (
      <CompleteInfoGatheringEarlyConfirmationDialog
        isOpen={vm.completeInfoGatheringConfirmationModalVm.showing}
        onClose={vm.completeInfoGatheringConfirmationModalVm.close}
        onConfirm={vm.confirmCompleteInfoGathering}
        isPending={vm.confirmCompleteInfoGathering.pending}
        testId={testId}
        confirmTestId={`${testId}-confirm-button`}
        closeTestId={`${testId}-close-button`}
      />
    )
  },
)
